import React, { useState } from 'react';

const Contact = () => {
  const [form, setForm] = useState({ name: '', email: '', message: '' });

  const onSubmit = (e) => {
    e.preventDefault();
    window.location.href = `mailto:marleyrozo@gmail.com?subject=Contacto%20desde%20portafolio&body=${encodeURIComponent(
      form.message
    )}`;
  };

  const inputClasses =
    "w-full mt-1 p-2 rounded border bg-white dark:bg-gray-800 text-black dark:text-white placeholder-gray-500 dark:placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-900";

  const references = [
    {
      name: "Liceth Yaneth Rozo Quintana",
      role: "Desarrolladora Backend Senior",
      company: "Finkargo Colombia SAS",
      email: "liyarozoquin12@gmail.com",
    },
    {
      name: "Jhon Andres Parra Rodriguez",
      role: "Analista especializado 1",
      company: "Banco Av Villas",
      email: "jhonandres0322@gmail.com",
    },
    {
      name: "Yonathan Carvajal",
      role: "Desarrollador Backend Senior",
      company: "Certicamara",
      email: "yonathan.carvajal@certicamara.com",
    },
    {
      name: "John Edward Osorio Carrero",
      role: "Director de Ingeniería",
      company: "Certicamara",
      email: "john.osorio@certicamara.com",
    },
  ];

  return (
    <section id="contact" aria-label="Contacto" className="py-10">
      <h2 className="text-2xl font-poppins mb-4">Contacto</h2>
      <div className="grid md:grid-cols-2 gap-6">
        
        {/* FORMULARIO */}
        <form
          onSubmit={onSubmit}
          className="p-4 rounded-lg border shadow-sm bg-white dark:bg-gray-900"
        >
          <label className="block mb-2">
            Nombre
            <input
              required
              value={form.name}
              onChange={(e) => setForm({ ...form, name: e.target.value })}
              className={inputClasses}
              placeholder="Tu nombre"
            />
          </label>
          <label className="block mb-2">
            Email
            <input
              required
              type="email"
              value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })}
              className={inputClasses}
              placeholder="tu@email.com"
            />
          </label>
          <label className="block mb-2">
            Mensaje
            <textarea
              required
              rows="4"
              value={form.message}
              onChange={(e) => setForm({ ...form, message: e.target.value })}
              className={inputClasses}
              placeholder="Escribe tu mensaje..."
            />
          </label>
          <div className="flex gap-3 mt-3">
            <button
              type="submit"
              className="px-4 py-2 rounded bg-blue-900 text-white font-medium hover:bg-blue-800 transition"
            >
              Enviar
            </button>
            <a
              href="https://wa.me/573142035583?text=Hola%20Yerika,%20interesado%20en%20tus%20servicios%20fullstack..."
              target="_blank"
              rel="noreferrer"
              className="px-4 py-2 rounded border hover:bg-gray-100 dark:hover:bg-gray-700 transition"
            >
              WhatsApp
            </a>
          </div>
        </form>

        {/* REFERENCIAS */}
        <div className="p-4 rounded-lg border shadow-sm bg-white dark:bg-gray-900">
          <h4 className="font-semibold mb-3">Referencias</h4>
          <ul className="space-y-4 text-sm">
            {references.map((ref, i) => (
              <li key={i} className="border-b pb-3 last:border-none">
                <p className="font-semibold text-black dark:text-white">
                  {ref.name}
                </p>
                <p className="text-gray-600 dark:text-gray-300">
                  {ref.role}, {ref.company}
                </p>
                <a
                  href={`mailto:${ref.email}`}
                  className="text-blue-900 dark:text-blue-400 hover:underline"
                >
                  {ref.email}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default Contact;
